
import { types, actions } from './requests'
export const DELETELABEL_TYPES = {
    ...types('DELETELABEL'),
}
export const DELETELABEL_ACTIONS = {
    ...actions('DELETELABEL'),
}